import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import './index.scss'

const TimeInput = ({ time, setTime, setDisableBtn }) => {
  return (
    <div className='wrapperTimeInput'>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <TimePicker
          openTo='hours'
          value={time}
          onChange={time => {
            setTime(new Date(time))
            if (setDisableBtn) {
              setDisableBtn(false)
            }
          }}
          variant='inline'
          inputVariant='outlined'
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}

export default TimeInput
